export class GetPortalAction {
	static readonly type = "[Portal] Get Details";
	constructor(public payload: string) {}
}

export class PortalNotFoundAction {
	static readonly type = "[Portal] Not Found";
}
